import qz from 'qz-tray';
import { initQZ } from './services/qz-config';

export const getShiftDetails = (now: Date) => {
  const hour = now.getHours();
  let shift: 'Morning' | 'Night';
  let businessDate = new Date(now);

  // Logic:
  // Morning: 09:00 AM (9) to 08:59 PM (20) -> Same Day
  // Night: 09:00 PM (21) to 08:59 AM (8)

  if (hour >= 21 || hour < 9) {
    shift = 'Night';
    // If it's early morning (e.g. 1 AM), the business date belongs to Yesterday
    if (hour < 9) {
      businessDate.setDate(businessDate.getDate() - 1);
    }
  } else {
    shift = 'Morning';
  }

  // Zero out time for clean date comparison
  businessDate.setHours(0, 0, 0, 0);
  return { shift, businessDate };
};

/* -----------------------------
   CONNECTION HELPERS
------------------------------ */
export const connectQZ = async () => {
  // Set the real certificate before every connection attempt so signing
  // works correctly regardless of which component triggered the print.
  initQZ();

  if (!qz.websocket.isActive()) {
    // Use wss:// when the page is served over HTTPS (e.g. nmdash.io) to
    // avoid browser mixed-content blocks. localhost.qz.io resolves to
    // 127.0.0.1 and QZ Tray ships a built-in TLS cert for that hostname.
    const useSecure = window.location.protocol === 'https:';
    await qz.websocket.connect({
      host: 'localhost.qz.io',
      port: { unsecure: [8182], secure: [8181] },
      usingSecure: useSecure,
    });
  }
};

/* -----------------------------
   TSPL GENERATOR (Fixed Layout)
------------------------------ */
export const generateTSPL = (
  title: string,
  barcode: string,
  price: number,
  size: string
) => {
  const safeTitle = title.length > 22 ? title.substring(0, 22) : title;

  /**
   * BARCODE CENTERING:
   * Total Width = 400 dots.
   * By setting X to 75, we provide enough room for the bars to grow 
   * while staying visually centered on a 50mm label.
   */
  return `SIZE 50 mm,25 mm
GAP 2 mm,0 mm
DIRECTION 1
CLS
TEXT 200,30,"2",0,1,1,2,"NIAMIA"
TEXT 20,65,"2",0,1,1,"${safeTitle}"
BARCODE 20,95,"128",50,0,0,2,2,"${barcode}"
TEXT 20,170,"2",0,1,1,"SIZE: ${size}"
TEXT 380,170,"3",0,1,1,3,"Rs.${price}"
PRINT 1
`;
};
/* -----------------------------
   PRINT FUNCTION
------------------------------ */
export const printLabel = async (
  printerName: string,
  title: string,
  barcode: string,
  price: number,
  size: string
) => {
  try {
    await connectQZ();

    // Find the TSC Printer
    const printer = await qz.printers.find(printerName);
    if (!printer) throw new Error(`Printer "${printerName}" not found.`);

    const config = qz.configs.create(printer);
    const tsplCommand = generateTSPL(title, barcode, price, size);

    await qz.print(config, [
      {
        type: "raw",
        format: "command",
        data: tsplCommand
      }
    ]);

    return true;
  } catch (err) {
    console.error("TSC Print failed:", err);
    throw err;
  }
};